import React, { useState, useEffect } from 'react';
import { decryptFile } from '../services/signalSession';

export default function E2EEAudio({
  fileData,
  senderId,
  currentUserId,
  fileId,
  onLoadedData,
  onClick,
  style,
  controls = true,
  autoPlay = false,
  muted = false,
  loop = false
}) {
  const [audioUrl, setAudioUrl] = useState(null);
  //const [error, setError] = useState(null);
const [failed, setFailed] = useState(false);

useEffect(() => {
    if (!fileData || !senderId || !currentUserId || !fileId) {
      console.error('❌ E2EEAudio : données manquantes', { fileData, senderId, currentUserId });
      setFailed(true);
      return;
    }


  

    let objectUrl = null;
    let cancelled = false;

    async function loadAudio() {
      try {
        //setError(null);

        

        const decrypted = await decryptFile(
          fileData,
          senderId,
          currentUserId,
          fileId
        );

        

        if (!decrypted || decrypted.byteLength === 0) {
          throw new Error('Fichier audio déchiffré vide');
        }

        if (cancelled) return;

        const mimeType =
          fileData.mimeType || 'audio/mpeg';

        const blob = new Blob(
          [decrypted],
          { type: mimeType }
        );

        if (blob.size === 0) {
          throw new Error('Blob audio vide');
        }

        objectUrl = URL.createObjectURL(blob);

        if (!cancelled) {
          setAudioUrl(objectUrl);
        }

      } catch (err) {
         console.error('❌ Erreur déchiffrement Audio:', fileId, err);
      if (!cancelled) setFailed(true); 
      }
    }

    loadAudio();

    return () => {
      cancelled = true;

      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [
    fileData,
    senderId,
    currentUserId,
    fileId
  ]);

  if (failed) {
    return null; 
  }


  if (!audioUrl) {
    return (
      <div>
        Chargement de l'audio...
      </div>
    );
  }

  return (
    <audio
      src={audioUrl}
      controls={controls}
      autoPlay={autoPlay}
      muted={muted}
      loop={loop}
      preload="auto"
      onLoadedData={onLoadedData}
      onClick={onClick}
      style={style}
    >
      Votre navigateur ne prend pas en charge la lecture audio.
    </audio>
  );
}
